import React from 'react';

// ============================================================
// ISOMETRIC BRAND ICONS FOR DECX AI
// Colors: Blue (#004AAD, #0082FB), White (#FFFFFF), Black (#090A0B)
// Style: Isometric 3D with depth and shadows
// Uses inline colors to avoid gradient ID conflicts
// ============================================================

// Color constants
const C = {
  primary: '#004AAD',
  secondary: '#0082FB',
  accent: '#00B4FF',
  gold: '#FFB800',
  goldDark: '#FF9500',
  green: '#10B981',
  greenDark: '#059669',
  deepBlue: '#002D6B',
  white: '#FFFFFF',
  black: '#090A0B'
};

// ============ NAVIGATION ICONS ============

export const MenuIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 5L12 2L20 5L12 8L4 5Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 5V7L12 10V8L4 5Z" fill={C.primary}/>
    <path d="M12 8V10L20 7V5L12 8Z" fill={C.secondary}/>
    <path d="M4 10L12 7L20 10L12 13L4 10Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 10V12L12 15V13L4 10Z" fill={C.primary}/>
    <path d="M12 13V15L20 12V10L12 13Z" fill={C.secondary}/>
    <path d="M4 15L12 12L20 15L12 18L4 15Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 15V17L12 20V18L4 15Z" fill={C.primary}/>
    <path d="M12 18V20L20 17V15L12 18Z" fill={C.secondary}/>
  </svg>
);

export const CloseIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M5 5L7 4L19 16L17 17L5 5Z" fill={C.accent}/>
    <path d="M5 5L5 7L17 19L17 17L5 5Z" fill={C.primary}/>
    <path d="M7 4L19 16L19 18L7 6L7 4Z" fill={C.secondary}/>
    <path d="M19 5L17 4L5 16L7 17L19 5Z" fill={C.accent}/>
    <path d="M19 5L19 7L7 19L7 17L19 5Z" fill={C.secondary}/>
    <path d="M17 4L5 16L5 18L17 6L17 4Z" fill={C.primary}/>
  </svg>
);

export const XIcon = CloseIcon;

export const ChevronDownIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M6 8L12 11L18 8L12 14L6 8Z" fill={C.accent}/>
    <path d="M6 8V10L12 16V14L6 8Z" fill={C.primary}/>
    <path d="M12 14V16L18 10V8L12 14Z" fill={C.secondary}/>
  </svg>
);

export const ChevronRightIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M8 6L11 12L8 18L14 12L8 6Z" fill={C.accent}/>
    <path d="M8 6L10 6L16 12L14 12L8 6Z" fill={C.secondary}/>
    <path d="M8 18L10 18L16 12L14 12L8 18Z" fill={C.primary}/>
  </svg>
);

export const ChevronLeftIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M16 6L13 12L16 18L10 12L16 6Z" fill={C.accent}/>
    <path d="M16 6L14 6L8 12L10 12L16 6Z" fill={C.primary}/>
    <path d="M16 18L14 18L8 12L10 12L16 18Z" fill={C.secondary}/>
  </svg>
);

export const ArrowRightIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 10L4 14L14 14L14 10L4 10Z" fill={C.accent}/>
    <path d="M4 10L4 12L14 12L14 10L4 10Z" fill={C.primary} opacity="0.8"/>
    <path d="M4 12L4 14L14 14L14 12L4 12Z" fill={C.secondary} opacity="0.6"/>
    <path d="M13 6L20 12L13 18L13 14L13 10L13 6Z" fill={C.accent}/>
    <path d="M13 6L13 18L15 16L15 8L13 6Z" fill={C.primary}/>
    <path d="M15 8L20 12L15 16L15 8Z" fill={C.secondary}/>
  </svg>
);

export const ArrowLeftIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M20 10L20 14L10 14L10 10L20 10Z" fill={C.accent}/>
    <path d="M20 10L20 12L10 12L10 10L20 10Z" fill={C.primary} opacity="0.8"/>
    <path d="M20 12L20 14L10 14L10 12L20 12Z" fill={C.secondary} opacity="0.6"/>
    <path d="M11 6L4 12L11 18L11 14L11 10L11 6Z" fill={C.accent}/>
    <path d="M11 18L11 6L9 8L9 16L11 18Z" fill={C.secondary}/>
    <path d="M9 8L4 12L9 16L9 8Z" fill={C.primary}/>
  </svg>
);

export const ArrowUpIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10 20L14 20L14 10L10 10L10 20Z" fill={C.accent}/>
    <path d="M10 10L10 20L12 20L12 10L10 10Z" fill={C.primary} opacity="0.8"/>
    <path d="M12 10L12 20L14 20L14 10L12 10Z" fill={C.secondary} opacity="0.6"/>
    <path d="M6 11L12 4L18 11L14 11L10 11L6 11Z" fill={C.accent}/>
    <path d="M6 11L12 4L12 6L8 11L6 11Z" fill={C.primary}/>
    <path d="M12 4L18 11L16 11L12 6L12 4Z" fill={C.secondary}/>
  </svg>
);

// ============ ACTION ICONS ============

export const CheckIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 12L9 17L20 6L18 4L9 13L6 10L4 12Z" fill={C.green}/>
    <path d="M4 12L4 14L9 19L9 17L4 12Z" fill={C.greenDark}/>
    <path d="M9 17L9 19L20 8L20 6L9 17Z" fill={C.green}/>
  </svg>
);

export const CheckCircleIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="10" ry="6" fill={C.accent} opacity="0.3"/>
    <circle cx="12" cy="12" r="9" fill="none" stroke={C.green} strokeWidth="2"/>
    <path d="M7 12L10 15L17 8" stroke={C.green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export const PlusIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10 4L14 4L14 10L20 10L20 14L14 14L14 20L10 20L10 14L4 14L4 10L10 10L10 4Z" fill={C.accent}/>
    <path d="M10 4L10 10L4 10L4 12L10 12L10 20L12 20L12 12L12 10L12 4L10 4Z" fill={C.primary} opacity="0.7"/>
    <path d="M12 4L12 10L12 12L12 20L14 20L14 12L20 12L20 10L14 10L14 4L12 4Z" fill={C.secondary} opacity="0.5"/>
  </svg>
);

export const MinusIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 10L20 10L20 14L4 14L4 10Z" fill={C.accent}/>
    <path d="M4 10L4 14L20 14L20 12L4 12L4 10Z" fill={C.primary} opacity="0.7"/>
    <path d="M4 12L20 12L20 14L4 14L4 12Z" fill={C.secondary} opacity="0.5"/>
  </svg>
);

export const UploadIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 3L7 8L9 8L9 14L15 14L15 8L17 8L12 3Z" fill={C.accent}/>
    <path d="M7 8L9 8L9 14L9 16L7 14L7 8Z" fill={C.primary} opacity="0.7"/>
    <path d="M15 8L17 8L17 14L15 16L15 14L15 8Z" fill={C.secondary} opacity="0.5"/>
    <path d="M4 16L12 13L20 16L12 19L4 16Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 16V18L12 21V19L4 16Z" fill={C.primary}/>
    <path d="M12 19V21L20 18V16L12 19Z" fill={C.secondary}/>
  </svg>
);

export const DownloadIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 15L7 10L9 10L9 4L15 4L15 10L17 10L12 15Z" fill={C.accent}/>
    <path d="M7 10L9 10L9 4L7 6L7 10Z" fill={C.primary} opacity="0.7"/>
    <path d="M15 10L17 10L17 6L15 4L15 10Z" fill={C.secondary} opacity="0.5"/>
    <path d="M4 17L12 14L20 17L12 20L4 17Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 17V19L12 22V20L4 17Z" fill={C.primary}/>
    <path d="M12 20V22L20 19V17L12 20Z" fill={C.secondary}/>
  </svg>
);

// ============ USER & AUTH ICONS ============

export const UserIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="7" rx="4" ry="3" fill={C.accent}/>
    <path d="M8 7C8 7 8 9 12 9C16 9 16 7 16 7" fill={C.primary} opacity="0.6"/>
    <path d="M6 20L12 14L18 20L12 22L6 20Z" fill={C.accent} opacity="0.9"/>
    <path d="M6 20V21L12 23V22L6 20Z" fill={C.primary}/>
    <path d="M12 22V23L18 21V20L12 22Z" fill={C.secondary}/>
  </svg>
);

export const UsersIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="9" cy="7" rx="3" ry="2.5" fill={C.accent}/>
    <path d="M4 18L9 13L14 18L9 20L4 18Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 18V19L9 21V20L4 18Z" fill={C.primary}/>
    <path d="M9 20V21L14 19V18L9 20Z" fill={C.secondary}/>
    <ellipse cx="16" cy="5" rx="2.5" ry="2" fill={C.secondary} opacity="0.7"/>
    <path d="M12 15L16 11L20 15L16 17L12 15Z" fill={C.secondary} opacity="0.6"/>
    <path d="M12 15V16L16 18V17L12 15Z" fill={C.primary} opacity="0.5"/>
    <path d="M16 17V18L20 16V15L16 17Z" fill={C.secondary} opacity="0.5"/>
  </svg>
);

export const MailIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M2 6L12 2L22 6L12 10L2 6Z" fill={C.accent}/>
    <path d="M2 6V16L12 20V10L2 6Z" fill={C.primary}/>
    <path d="M12 10V20L22 16V6L12 10Z" fill={C.secondary}/>
    <path d="M2 6L12 12L22 6L12 10L2 6Z" fill={C.accent} opacity="0.8"/>
  </svg>
);

export const LockIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M6 10L12 7L18 10L12 13L6 10Z" fill={C.accent}/>
    <path d="M6 10V18L12 21V13L6 10Z" fill={C.primary}/>
    <path d="M12 13V21L18 18V10L12 13Z" fill={C.secondary}/>
    <path d="M8 10V7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7V10" stroke={C.secondary} strokeWidth="2" fill="none" strokeLinecap="round"/>
    <ellipse cx="12" cy="15" rx="1.5" ry="1" fill={C.black}/>
  </svg>
);

export const LogOutIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 4L10 2L10 20L4 22L4 4Z" fill={C.primary}/>
    <path d="M10 2L14 4L14 22L10 20L10 2Z" fill={C.secondary} opacity="0.7"/>
    <path d="M14 10L20 10L20 14L14 14L14 10Z" fill={C.accent}/>
    <path d="M17 7L22 12L17 17L17 14L17 10L17 7Z" fill={C.accent}/>
  </svg>
);

// ============ PAYMENT & FINANCE ICONS ============

export const CreditCardIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M2 8L12 4L22 8L12 12L2 8Z" fill={C.accent}/>
    <path d="M2 8V16L12 20V12L2 8Z" fill={C.primary}/>
    <path d="M12 12V20L22 16V8L12 12Z" fill={C.secondary}/>
    <path d="M2 10L12 6L22 10L12 14L2 10Z" fill={C.black} opacity="0.8"/>
    <rect x="5" y="14" width="3" height="2" rx="0.5" fill={C.gold} transform="skewY(-15)"/>
  </svg>
);

export const ShieldIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 2L4 6V12C4 16.4 7.6 20 12 21C16.4 20 20 16.4 20 12V6L12 2Z" fill={C.accent} opacity="0.9"/>
    <path d="M4 6V12C4 16.4 7.6 20 12 21V2L4 6Z" fill={C.primary}/>
    <path d="M12 2V21C16.4 20 20 16.4 20 12V6L12 2Z" fill={C.secondary}/>
    <path d="M8 12L11 15L16 10" stroke={C.white} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export const CoinsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="10" cy="16" rx="6" ry="3" fill={C.gold} opacity="0.6"/>
    <path d="M4 14V16C4 17.66 6.69 19 10 19C13.31 19 16 17.66 16 16V14" fill={C.gold} opacity="0.4"/>
    <ellipse cx="12" cy="12" rx="6" ry="3" fill={C.gold} opacity="0.8"/>
    <path d="M6 10V12C6 13.66 8.69 15 12 15C15.31 15 18 13.66 18 12V10" fill={C.gold} opacity="0.6"/>
    <ellipse cx="14" cy="8" rx="6" ry="3" fill={C.gold}/>
    <path d="M8 6V8C8 9.66 10.69 11 14 11C17.31 11 20 9.66 20 8V6" fill={C.gold} opacity="0.8"/>
  </svg>
);

// ============ PLAN & TIER ICONS ============

export const ZapIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M13 2L6 12H11L10 22L18 10H13L13 2Z" fill={C.gold}/>
    <path d="M13 2L6 12H8L13 4L13 2Z" fill={C.gold} opacity="0.9"/>
    <path d="M10 22L18 10H16L11 20L10 22Z" fill={C.goldDark} opacity="0.8"/>
  </svg>
);

export const StarIcon = ({ size = 24, filled = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path 
      d="M12 2L14.5 8.5L21.5 9.5L16.5 14L18 21L12 17.5L6 21L7.5 14L2.5 9.5L9.5 8.5L12 2Z" 
      fill={filled ? C.gold : "none"} 
      stroke={C.gold} 
      strokeWidth="1.5"
    />
    {filled && (
      <>
        <path d="M12 2L9.5 8.5L2.5 9.5L7.5 14L6 21L12 17.5V2Z" fill={C.gold} opacity="0.8"/>
        <path d="M12 2L14.5 8.5L21.5 9.5L16.5 14L18 21L12 17.5V2Z" fill={C.gold}/>
      </>
    )}
  </svg>
);

export const SparklesIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 2L13.5 7L19 8L13.5 9L12 14L10.5 9L5 8L10.5 7L12 2Z" fill={C.accent}/>
    <path d="M12 2L10.5 7L5 8L10.5 9L12 14V2Z" fill={C.primary} opacity="0.7"/>
    <path d="M12 2L13.5 7L19 8L13.5 9L12 14V2Z" fill={C.secondary} opacity="0.5"/>
    <path d="M19 14L20 16L22 17L20 18L19 20L18 18L16 17L18 16L19 14Z" fill={C.accent} opacity="0.8"/>
    <path d="M5 15L6 17L8 18L6 19L5 21L4 19L2 18L4 17L5 15Z" fill={C.accent} opacity="0.6"/>
  </svg>
);

export const CrownIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 16L6 8L9 11L12 5L15 11L18 8L20 16H4Z" fill={C.gold}/>
    <path d="M4 16L6 8L9 11L12 5L12 16H4Z" fill={C.gold} opacity="0.9"/>
    <path d="M12 5L15 11L18 8L20 16H12V5Z" fill={C.goldDark} opacity="0.8"/>
    <path d="M4 16L12 14L20 16L12 18L4 16Z" fill={C.gold}/>
    <path d="M4 16V18L12 20V18L4 16Z" fill={C.goldDark}/>
    <path d="M12 18V20L20 18V16L12 18Z" fill={C.gold}/>
    <circle cx="8" cy="14" r="1" fill={C.secondary}/>
    <circle cx="12" cy="13" r="1" fill={C.secondary}/>
    <circle cx="16" cy="14" r="1" fill={C.secondary}/>
  </svg>
);

// ============ PERSONA ICONS ============

export const RocketIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 2C12 2 6 8 6 14C6 16 8 18 12 18C16 18 18 16 18 14C18 8 12 2 12 2Z" fill={C.accent}/>
    <path d="M6 14C6 16 8 18 12 18V2C12 2 6 8 6 14Z" fill={C.primary}/>
    <path d="M12 2V18C16 18 18 16 18 14C18 8 12 2 12 2Z" fill={C.secondary}/>
    <ellipse cx="12" cy="10" rx="2" ry="1.5" fill={C.accent} opacity="0.8"/>
    <path d="M6 18L4 22L8 20L6 18Z" fill={C.primary}/>
    <path d="M18 18L20 22L16 20L18 18Z" fill={C.secondary}/>
    <path d="M10 18L12 23L14 18L12 20L10 18Z" fill={C.gold}/>
  </svg>
);

export const TargetIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="10" ry="5" fill={C.accent} opacity="0.3"/>
    <ellipse cx="12" cy="12" rx="10" ry="5" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <ellipse cx="12" cy="12" rx="6" ry="3" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <ellipse cx="12" cy="12" rx="2" ry="1" fill={C.secondary}/>
  </svg>
);

export const BriefcaseIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M3 9L12 5L21 9L12 13L3 9Z" fill={C.accent}/>
    <path d="M3 9V17L12 21V13L3 9Z" fill={C.primary}/>
    <path d="M12 13V21L21 17V9L12 13Z" fill={C.secondary}/>
    <path d="M9 5V3C9 2 10 1 12 1C14 1 15 2 15 3V5" stroke={C.secondary} strokeWidth="2" fill="none"/>
    <ellipse cx="12" cy="12" rx="2" ry="1" fill={C.black}/>
  </svg>
);

export const BuildingIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M6 6L12 3L18 6L12 9L6 6Z" fill={C.accent}/>
    <path d="M6 6V20L12 23V9L6 6Z" fill={C.primary}/>
    <path d="M12 9V23L18 20V6L12 9Z" fill={C.secondary}/>
    <rect x="7" y="10" width="2" height="2" fill={C.accent} opacity="0.8" transform="skewY(-30)"/>
    <rect x="7" y="14" width="2" height="2" fill={C.accent} opacity="0.8" transform="skewY(-30)"/>
    <rect x="13" y="11" width="2" height="2" fill={C.accent} opacity="0.6" transform="skewY(30)"/>
    <rect x="13" y="15" width="2" height="2" fill={C.accent} opacity="0.6" transform="skewY(30)"/>
  </svg>
);

export const Building2Icon = BuildingIcon;

// ============ UI ICONS ============

export const SunIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="5" fill={C.gold}/>
    <path d="M12 2V5" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 19V22" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M4.22 4.22L6.34 6.34" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M17.66 17.66L19.78 19.78" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M2 12H5" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M19 12H22" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M4.22 19.78L6.34 17.66" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
    <path d="M17.66 6.34L19.78 4.22" stroke={C.gold} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const MoonIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill={C.accent}/>
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill={C.primary} opacity="0.4"/>
  </svg>
);

export const BellIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 3L6 8V14L4 17H20L18 14V8L12 3Z" fill={C.accent}/>
    <path d="M6 8V14L4 17H12V3L6 8Z" fill={C.primary}/>
    <path d="M12 3V17H20L18 14V8L12 3Z" fill={C.secondary}/>
    <ellipse cx="12" cy="20" rx="2" ry="1" fill={C.secondary}/>
  </svg>
);

export const SearchIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="10" cy="10" rx="7" ry="4" fill={C.accent} opacity="0.3"/>
    <circle cx="10" cy="10" r="6" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <path d="M15 14L21 20" stroke={C.secondary} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const LoaderIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle 
      cx="12" cy="12" r="8" 
      fill="none"
      stroke={C.secondary} 
      strokeWidth="3" 
      strokeDasharray="30 70"
      strokeLinecap="round"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export const Loader2Icon = LoaderIcon;

export const AlertCircleIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="10" ry="5" fill={C.accent} opacity="0.2"/>
    <circle cx="12" cy="12" r="9" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <path d="M12 7V12" stroke={C.secondary} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="16" r="1" fill={C.secondary}/>
  </svg>
);

export const QuoteIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M7 6L11 6L11 10C11 14 7 14 7 14V12C9 12 9 10 9 10H7V6Z" fill={C.secondary}/>
    <path d="M7 6L9 5L11 6L11 10C11 14 7 14 7 14V12L9 11V10H7V6Z" fill={C.primary} opacity="0.7"/>
    <path d="M14 6L18 6L18 10C18 14 14 14 14 14V12C16 12 16 10 16 10H14V6Z" fill={C.secondary}/>
    <path d="M14 6L16 5L18 6L18 10C18 14 14 14 14 14V12L16 11V10H14V6Z" fill={C.secondary} opacity="0.5"/>
  </svg>
);

export const EyeIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" fill={C.accent} opacity="0.3"/>
    <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <circle cx="12" cy="12" r="3" fill={C.secondary}/>
    <circle cx="12" cy="12" r="1" fill={C.black}/>
  </svg>
);

export const HomeIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 2L3 9L12 7L21 9L12 2Z" fill={C.accent}/>
    <path d="M3 9L3 19L12 21L12 7L3 9Z" fill={C.primary}/>
    <path d="M12 7L12 21L21 19L21 9L12 7Z" fill={C.secondary}/>
    <path d="M10 21V16H14V21" fill={C.black} opacity="0.8"/>
  </svg>
);

export const FileTextIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M6 4L14 2L20 6L12 8L6 4Z" fill={C.accent}/>
    <path d="M6 4V20L12 22V8L6 4Z" fill={C.primary}/>
    <path d="M12 8V22L20 18L20 6L12 8Z" fill={C.secondary}/>
    <path d="M8 10L10 10" stroke={C.white} strokeWidth="1" opacity="0.6"/>
    <path d="M8 13L11 13" stroke={C.white} strokeWidth="1" opacity="0.6"/>
    <path d="M8 16L10 16" stroke={C.white} strokeWidth="1" opacity="0.6"/>
  </svg>
);

export const BarChartIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M3 16L7 14L7 20L3 22L3 16Z" fill={C.primary}/>
    <path d="M7 14L11 16L11 22L7 20L7 14Z" fill={C.secondary}/>
    <path d="M3 16L7 14L11 16L7 18L3 16Z" fill={C.accent}/>
    <path d="M8 12L12 10L12 20L8 22L8 12Z" fill={C.primary}/>
    <path d="M12 10L16 12L16 22L12 20L12 10Z" fill={C.secondary}/>
    <path d="M8 12L12 10L16 12L12 14L8 12Z" fill={C.accent}/>
    <path d="M13 6L17 4L17 18L13 20L13 6Z" fill={C.primary}/>
    <path d="M17 4L21 6L21 20L17 18L17 4Z" fill={C.secondary}/>
    <path d="M13 6L17 4L21 6L17 8L13 6Z" fill={C.accent}/>
  </svg>
);

export const SettingsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 8L14 7L15 9L17 9L18 11L17 13L18 15L16 16L15 18L13 17L11 18L10 16L8 16L7 14L8 12L7 10L9 9L10 7L12 8Z" fill={C.accent}/>
    <path d="M7 10L9 9L10 7L12 8L12 12L7 14L7 10Z" fill={C.primary} opacity="0.7"/>
    <path d="M12 8L14 7L15 9L17 9L18 11L12 12L12 8Z" fill={C.secondary} opacity="0.5"/>
    <circle cx="12" cy="12" r="3" fill={C.black} opacity="0.9"/>
  </svg>
);

export const ClockIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="10" ry="5" fill={C.accent} opacity="0.2"/>
    <circle cx="12" cy="12" r="9" fill="none" stroke={C.secondary} strokeWidth="2"/>
    <path d="M12 6V12L15 14" stroke={C.secondary} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="1" fill={C.secondary}/>
  </svg>
);

export const TrendingUpIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M2 17L8 11L13 16L22 7" stroke={C.green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 7H22V13" stroke={C.green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M2 19L8 13L13 18L22 9" stroke={C.green} strokeWidth="1" strokeLinecap="round" opacity="0.3"/>
  </svg>
);

// ============ SOCIAL/BRAND ICONS ============

export const LinkedInIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 4L12 2L20 4L12 6L4 4Z" fill={C.accent}/>
    <path d="M4 4V18L12 20V6L4 4Z" fill={C.primary}/>
    <path d="M12 6V20L20 18V4L12 6Z" fill={C.secondary}/>
    <path d="M7 9V14" stroke={C.white} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="7" cy="7" r="1" fill={C.white}/>
    <path d="M11 14V11.5C11 10.5 12 9.5 13 9.5C14 9.5 15 10.5 15 11.5V14" stroke={C.white} strokeWidth="2" strokeLinecap="round"/>
    <path d="M11 9V14" stroke={C.white} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// ============ DEFAULT EXPORT ============

export default {
  Menu: MenuIcon,
  Close: CloseIcon,
  X: XIcon,
  ChevronDown: ChevronDownIcon,
  ChevronRight: ChevronRightIcon,
  ChevronLeft: ChevronLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowUp: ArrowUpIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  Plus: PlusIcon,
  Minus: MinusIcon,
  Upload: UploadIcon,
  Download: DownloadIcon,
  User: UserIcon,
  Users: UsersIcon,
  Mail: MailIcon,
  Lock: LockIcon,
  LogOut: LogOutIcon,
  CreditCard: CreditCardIcon,
  Shield: ShieldIcon,
  Coins: CoinsIcon,
  Zap: ZapIcon,
  Star: StarIcon,
  Sparkles: SparklesIcon,
  Crown: CrownIcon,
  Rocket: RocketIcon,
  Target: TargetIcon,
  Briefcase: BriefcaseIcon,
  Building: BuildingIcon,
  Building2: Building2Icon,
  Sun: SunIcon,
  Moon: MoonIcon,
  Bell: BellIcon,
  Search: SearchIcon,
  Loader: LoaderIcon,
  Loader2: Loader2Icon,
  AlertCircle: AlertCircleIcon,
  Quote: QuoteIcon,
  Eye: EyeIcon,
  Home: HomeIcon,
  FileText: FileTextIcon,
  BarChart: BarChartIcon,
  Settings: SettingsIcon,
  Clock: ClockIcon,
  TrendingUp: TrendingUpIcon,
  LinkedIn: LinkedInIcon
};
